// tslint:disable
export var DebitCardVmcUsageRegion;
(function (DebitCardVmcUsageRegion) {
    // Unknown
    DebitCardVmcUsageRegion[DebitCardVmcUsageRegion["Unknown"] = 0] = "Unknown";
    // USA
    DebitCardVmcUsageRegion[DebitCardVmcUsageRegion["USA"] = 1] = "USA";
    // international
    DebitCardVmcUsageRegion[DebitCardVmcUsageRegion["international"] = 2] = "international";
})(DebitCardVmcUsageRegion || (DebitCardVmcUsageRegion = {}));
DebitCardVmcUsageRegion['UNKNOWN'] = 0;
DebitCardVmcUsageRegion['INTERNATIONAL'] = 2;
//# sourceMappingURL=DebitCardVmcUsageRegion.js.map